(() => {
  const intros = {
    all: 'Erst an den Menschen denken, dann ans Geschenkpapier. Hier sind meine Ideen für deine Lieblingsmenschen.',
    partner: 'Für den Menschen, mit dem selbst ein gewöhnlicher Dienstag eine gute Erinnerung werden kann. Genau dort würde ich nach dem Geschenk suchen.',
    freunde: 'Für eure Insider, Lachanfälle und die Person, die immer noch zuhört. Auch wenn sie die Geschichte längst kennt.',
    mama: 'Für Mama darf es persönlich sein. Ein Familienmoment, eure Namen oder ein Hoodie für ihre große Weihnachtsliebe – du kennst sie am besten.',
    papa: 'Für Papa, der angeblich nichts braucht. Ich würde trotzdem einmal schauen, worüber er sich wirklich freuen würde.',
    weihnachten: 'Für alle, denen ein Tannenbaum im Wohnzimmer noch nicht festlich genug ist. Diese Hoodies bringen die Weihnachtsstimmung gleich mit.'
  };
  const priorities = {
    mama: ['mama-t-shirt-hot-mama-rundhals-personalisiert-mit-deinen-fotos', 'mom-who-loves-christmas-hoodie', 'mama-hoodie-solid-rocks-personalisiert', 'mama-hoodie-minimal-personalisiert'],
    papa: ['papa-hoodie-best-dad-mit-euren-fotos-personalisiert', 'papa-hoodie-christmas-dads-fine', 'papa-t-shirt-best-dad-rundhals-personalisiert-mit-deinen-fotos', 'papa-hoodie-minimal-personalisiert'],
    partner: ['my-love-hoodie-mit-euren-fotos-personalisiert', 'my-love-t-shirt-mit-euren-fotos-rundhals-personalisiert', 'hoodie-outline-aus-eurem-fotos-personalisiert', 'foto-poster-karikatur-mit-bild-personalisiert']
  };
  function init(root) {
    if (root.dataset.giftsReady) return;
    const controls = root.querySelector('.xmas-discovery');
    if (!controls) return;
    root.dataset.giftsReady = 'true';
    const grid = root.querySelector('.xmas-grid');
    const cards = [...grid.querySelectorAll('.xmas-product')];
    const buttons = [...controls.querySelectorAll('[data-gift-filter]')];
    const sort = controls.querySelector('[data-gift-sort]');
    const count = root.querySelector('.xmas-count');
    let group = 'all';
    count.setAttribute('aria-live', 'polite');
    const rank = card => {
      const handle = new URL(card.querySelector('h3 a').href).pathname.split('/').pop();
      const index = (priorities[group] || []).indexOf(handle);
      return index < 0 ? 100 + Number(card.dataset.giftOrder) : index;
    };
    function update() {
      const ordered = [...cards].sort((a, b) => {
        if (sort.value === 'price-asc') return Number(a.dataset.giftPrice) - Number(b.dataset.giftPrice) || rank(a) - rank(b);
        if (sort.value === 'price-desc') return Number(b.dataset.giftPrice) - Number(a.dataset.giftPrice) || rank(a) - rank(b);
        return rank(a) - rank(b);
      });
      let visible = 0;
      ordered.forEach(card => {
        card.hidden = group !== 'all' && !card.dataset.giftGroups.split(' ').includes(group);
        if (!card.hidden) visible += 1;
        grid.append(card);
      });
      count.textContent = `${visible} ${visible === 1 ? 'Geschenkidee' : 'Geschenkideen'}`;
      controls.querySelector('.xmas-filter-intro').textContent = intros[group];
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.giftFilter === group)));
    }
    buttons.forEach(button => button.addEventListener('click', () => { group = button.dataset.giftFilter; update(); }));
    sort.addEventListener('change', update);
    controls.hidden = false;
    update();
  }
  document.querySelectorAll('.xmas-shop').forEach(init);
  if (!window.uwsChristmasEditorListener) {
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.xmas-shop').forEach(init));
    window.uwsChristmasEditorListener = true;
  }
})();
